import React, { useRef, useState } from "react";
import { FaLock } from "react-icons/fa6";
import AURAIMG from "../assets/images/AURA.jpg";
import BeFreeCover from "../assets/images/be-free-cover.gif";
import BeFreeCover2 from "../assets/images/be-free-cover-2.png";
import BeFreeCover3 from "../assets/images/be-free-cover-3.png";
import DarknessBG from "../assets/images/darkness.gif";
import AuraVideo from "../assets/videos/aura-video.mp4";
import Nav2 from "../Nav2";
import BeFreeSong from "../assets/music/be-free-master.wav";
import BeFreeVideo from "../assets/videos/BE-FREE.mp4";
import BeFreeScat1 from "../assets/music/befree-please.m4a";
import BeFreeScat2 from "../assets/music/be free - shining nigga.m4a";
import BeFreeScat3 from "../assets/music/be free - slacking-happy.m4a";

const BeFreeImages = [BeFreeCover, BeFreeCover2, BeFreeCover3];
const BeFreeVideos = [BeFreeVideo];
const BeFreeScats = [BeFreeScat1, BeFreeScat2, BeFreeScat3];

export const BeFreeSection = () => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const handleMouseMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = e.clientX.toFixed(0);
    const y = e.clientY.toFixed(0);
    setPos({ x, y });
  };
  const mask = `
            radial-gradient(
            circle calc(100vw * 0.6) at ${pos.x}px ${pos.y}px,
            transparent 0%,
            black 80%
          )
    `;

  const backgroundCircle = `
    radial-gradient(circle at ${pos.x}px ${pos.y}px, rgba(255,255,255,0.5), transparent 60%) 
    `;

  return (
    <div ref={ref} onMouseMove={handleMouseMove}>
      {/* <Nav2 /> */}
      <img src={DarknessBG} className="fixed h-full w-full lg:ml-[7.5px]" />
      <div className="relative flex w-[100vw] flex-col items-center overflow-y-auto p-[0_20px] text-white">
        <div
          style={{
            position: "fixed",
            inset: 0,
            pointerEvents: "none",
            zIndex: 50,
            background: "rgba(0,0,0,0.75)",
            WebkitMaskImage: mask,
            maskImage: mask,
          }}
        ></div>
        <div
          style={{
            position: "fixed",
            inset: "-20px",
            pointerEvents: "none",
            background: backgroundCircle,
          }}
        ></div>
        <h2
          style={{
            fontSize: "2vw",
            marginTop: "10px",
            textAlign: "center",
            color: "lightgray",
          }}
        >
          Episode 1
        </h2>
        <h1 className="max-w-[600px] text-center text-[4vw] font-bold">
          WHATS DONE IN THE DARK
        </h1>
        <h1 className="max-w-[600px] text-center text-[4vw] font-bold">
          COMES TO LIGHT
        </h1>
        <h2
          style={{
            fontSize: "2vw",
            textAlign: "center",
            width: "70%",
          }}
        >
          Are people too comfortable staying in the dark?
        </h2>

        <div className="mb-4 mt-4 flex w-[90%] flex-col items-center gap-[5px] text-center text-xl lg:text-[3vh]">
          <p className="my-1 text-3xl font-[800] underline lg:text-[44px]">
            Segments:
          </p>
          <p className="font-[600]">Segment 1: Be Free</p>
          {[0, 1, 2].map((_, index) => (
            <div className="flex select-none items-center gap-2 text-[gray]">
              <FaLock />
              <p>Segment {index + 2}: ? </p>
            </div>
          ))}
        </div>

        <div
          // className="mb-4 mt-4 grid w-[90%] grid-cols-[1fr_1.5fr] gap-4"
          className="mb-8 mt-8 flex flex-col gap-4"
        >
          <div className="flex w-full flex-col items-center justify-center gap-2.5 pl-5 pr-5 text-left text-lg lg:text-3xl">
            <div className="flex flex-col gap-1 lg:gap-2.5">
              <p className="w-full underline">Segment 1</p>
              <p className="mt-[-5px] w-full lg:text-xl">Be Free</p>
              {/* <p className="w-full lg:text-xl">Song Segment</p> */}
              <p className="text-sm lg:text-lg">
                The freedom to be who you want to be and love whoever you want.
              </p>
              <audio
                className="mb-4 mt-4 w-full"
                controls
                src={BeFreeSong}
                // playsInline
              />
            </div>
            <div className=" grid w-full grid-flow-row grid-cols-3 gap-2">
              {BeFreeImages.map((image, index) => (
                <div key={index} className="box-border">
                  <img className="w-full" src={image} alt="" />
                  <p className="text-center text-sm lg:text-xl">
                    Artwork {index + 1}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center gap-4">
            <video
              className="flex w-full"
              controls={false}
              preload="metadata"
              playsInline
              autoPlay
              loop
              muted
              src={BeFreeVideos[0]}
              type="video/mp4"
            />
          </div>
        </div>
        <p className=""></p>
        <div className="mb-4 mt-4 grid w-full grid-flow-col gap-4 ">
          {BeFreeScats.map((scat, index) => (
            <div
              key={index}
              className="box-border flex w-full flex-col items-center"
            >
              <p>Scat {index + 1}</p>
              {/* <img className="" src={AURAIMG} alt="" /> */}
              <audio
                className=" w-full"
                controls
                src={scat}
                // playsInline
              />
            </div>
          ))}
        </div>
      </div>
      {/* <div className="ls-2 relative grid w-[100vw] grid-cols-[1.5fr_1fr] items-center gap-4 overflow-y-auto bg-black p-[0_20px] pt-[10px] text-white">
        <div className="flex flex-col self-start">
          <h2 className="area col-start-[1]  w-full text-center text-[2vw] text-[lightgray]">
            Episode 1
          </h2>
          <h1 className="col-start-[1] text-center text-[3vw] font-bold">
            WHATS DONE IN THE DARK COMES TO LIGHT
          </h1>
          <h1 className="col-span-2 text-center text-[2vw]">
            Are people too comfortable staying in the dark?
          </h1>
          <div className="mb-4 mt-4 flex w-[90%] flex-col items-center text-center">
            <p> Segment Index </p>
            <p>Segment 1: Be Free</p>
            {[0, 1, 2].map((_, index) => (
              <div className="flex select-none items-center gap-2 text-[gray]">
                <FaLock />
                <p>Segment {index + 2}: -</p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-center gap-4">
          <div className=" grid w-full grid-flow-row grid-cols-3 gap-2">
            {BeFreeImages.map((image, index) => (
              <div key={index} className="box-border">
                <img className="" src={image} alt="" />
                <p className="text-center text-[10px]">Image: {index + 1}</p>
              </div>
            ))}
          </div>
          <video
            className="flex w-full"
            controls={false}
            preload="metadata"
            playsInline
            autoPlay
            loop
            muted
            src={BeFreeVideos[0]}
            type="video/mp4"
          />
        </div>
      </div> */}
    </div>
  );
};
